/* eslint-disable camelcase */

import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ApiResponse, ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosHVS";
import { Attribute } from "./hvsBase";
import { IconData } from "./incidentType";

export interface EventType extends Record<string, unknown> {
  id: string;
  name: string;
  attributes: Record<string, Attribute>;
  appearance: IconData;
}

export interface EventTypeDetail extends Record<string, unknown> {
  entity_type: EventType;
}

const baseKey = "/entitytypes";

export const useEventTypes = (
  config?: SWRConfiguration
): ServerResponse<ApiArrayResponse<EventType>> =>
  useSwr<ApiArrayResponse<EventType>>(`${baseKey}/events`, config);

export const useEventType = (
  id?: string,
  config?: SWRConfiguration
): ServerResponse<ApiResponse<EventType>> =>
  useSwr<ApiResponse<EventType>>(
    id != null && id !== "" ? `${baseKey}/${id}` : null,
    config
  );
